import axios from 'axios';

import {
	AUTHENTICATION_PENDING,
	AUTHENTICATION_FULFILLED,
	AUTHENTICATION_FAILED
} from '../constants/auth.actions';
import { BASE_API_URL } from '../constants/urls';

export const fetchAuthInfoPending = () => {
	return {
		type: AUTHENTICATION_PENDING,
		payload: null
	};
};

export const fetchAuthInfoFulfilled = (info) => {
	return {
		type: AUTHENTICATION_FULFILLED,
		payload: {
			info
		}
	};
};

export const fetchAuthInfoFailed = (status) => {
	return {
		type: AUTHENTICATION_FAILED,
		payload: {
			status
		}
	};
};

export const fetchAuthInfo = () => {
	return async function(dispatch) {
		dispatch(fetchAuthInfoPending());

		try {
			const response = await axios(`${BASE_API_URL}/auth`);
			dispatch(fetchAuthInfoFulfilled(response.data));
		} catch(error) {
			dispatch(fetchAuthInfoFailed(500));
		}
	};
};
